import React from 'react';
import styled from 'styled-components';
import ImpContainer from '../../Atoms/ImpContainer/ImpContainer';
import ImpFlex from '../../Atoms/ImpFlex/ImpFlex';
import ImpPad from '../../Atoms/ImpPad/ImpPad';
import ImpSurface from '../../Atoms/ImpSurface/ImpSurface';
import { colors } from '../../DesignSystem/colors';
import ImpText from '../../Molecules/ImpText/ImpText';
import ImpProgressRing from '../ImpProgressRing/ImpProgressRing';
const LoyaltyText = styled(ImpContainer) `
  && p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
`;
export function ImpLoyaltyTracker({ title, color, percentComplete, subtitle, }) {
    const isComplete = percentComplete === 100;
    return (React.createElement(ImpContainer, { width: "100%" },
        React.createElement("div", { style: {
                minWidth: '132px',
                height: '100%',
            } },
            React.createElement(ImpSurface, { hasBorderRadius: true, surfaceColor: colors.surface.surfaceMid, fluid: true },
                React.createElement(ImpPad, { fluid: true, padding: "16px" },
                    React.createElement(ImpFlex, { fluid: true, direction: "column", align: "center", gap: "l" },
                        React.createElement(LoyaltyText, null,
                            React.createElement(ImpText, { typography: "label3" }, title)),
                        isComplete ? (React.createElement(ImpProgressRing, { complete: true, small: true, rings: [{ percentComplete, color }] })) : (React.createElement(ImpProgressRing, { small: true, rings: [{ percentComplete, color }] })),
                        React.createElement(LoyaltyText, null,
                            React.createElement(ImpText, { typography: "body3", color: colors.content.onSurfaceVariant }, subtitle))))))));
}
//# sourceMappingURL=ImpLoyaltyTracker.js.map